const DRAG_THRESHOLD = 5;

class CategoryCarousel extends HTMLElement {
  #scroll = null;
  #pointerId = null;
  #startX = 0;
  #startScrollLeft = 0;
  #mql = window.matchMedia("(min-width: 768px) and (pointer: fine)");

  connectedCallback() {
    this.#scroll = this.querySelector("[data-category-scroll]");
    if (!this.#scroll) return;
    this.#scroll.addEventListener("pointerdown", this.#onPointerDown);
    this.addEventListener("click", this.#onClickCapture, true);
    this.addEventListener("dragstart", this.#onDragStart);
  }

  disconnectedCallback() {
    this.#scroll?.removeEventListener("pointerdown", this.#onPointerDown);
    this.removeEventListener("click", this.#onClickCapture, true);
    this.removeEventListener("dragstart", this.#onDragStart);
    document.removeEventListener("pointermove", this.#onPointerMove);
    document.removeEventListener("pointerup", this.#onPointerUp);
    document.removeEventListener("pointercancel", this.#onPointerUp);
  }

  #onPointerDown = (event) => {
    if (!this.#mql.matches) return;
    if (event.pointerType !== "mouse") return;
    if (event.button !== 0) return;

    this.#pointerId = event.pointerId;
    this.#startX = event.clientX;
    this.#startScrollLeft = this.#scroll.scrollLeft;

    document.addEventListener("pointermove", this.#onPointerMove);
    document.addEventListener("pointerup", this.#onPointerUp);
    document.addEventListener("pointercancel", this.#onPointerUp);
  };

  #onPointerMove = (event) => {
    if (event.pointerId !== this.#pointerId) return;
    const dx = event.clientX - this.#startX;
    if (this.dataset.dragging !== "true" && Math.abs(dx) > DRAG_THRESHOLD) {
      this.dataset.dragging = "true";
    }
    if (this.dataset.dragging === "true") {
      event.preventDefault();
      this.#scroll.scrollLeft = this.#startScrollLeft - dx;
    }
  };

  #onPointerUp = (event) => {
    if (event.pointerId !== this.#pointerId) return;
    document.removeEventListener("pointermove", this.#onPointerMove);
    document.removeEventListener("pointerup", this.#onPointerUp);
    document.removeEventListener("pointercancel", this.#onPointerUp);
    this.#pointerId = null;
    if (this.dataset.dragging === "true") {
      requestAnimationFrame(() => {
        delete this.dataset.dragging;
      });
    }
  };

  #onClickCapture = (event) => {
    if (this.dataset.dragging === "true") {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  #onDragStart = (event) => {
    if (this.#mql.matches) event.preventDefault();
  };
}

if (!customElements.get("category-carousel")) {
  customElements.define("category-carousel", CategoryCarousel);
}
